import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  PaneFooter,
} from '@folio/stripes/components';
import { FormattedMessage } from 'react-intl';

const FormPaneFooter = props => {
  const {
    form,
    pristine,
    submitting,
    onCancel,
    handleSubmit
  } = props;

  const { hasValidationErrors } = form.getState();
  const disabled = pristine || submitting;

  const startButton = (
    <Button
      data-test-cancel
      marginBottom0
      buttonStyle="default mega"
      disabled={disabled}
      id="clickable-cancel"
      onClick={onCancel}
    >
      <FormattedMessage id="ui-task-list.form.btn.cancel" />
    </Button>
  );

  const endButton = (
    <Button
      data-test-save
      marginBottom0
      buttonStyle="primary mega"
      disabled={disabled || hasValidationErrors}
      id="clickable-save"
      type="submit"
      onClick={handleSubmit}
    >
      <FormattedMessage id="ui-task-list.form.btn.saveAndClose" />
    </Button>
  );

  return (
    <PaneFooter
      renderEnd={endButton}
      renderStart={startButton}
    />
  );
};

FormPaneFooter.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getState: PropTypes.func.isRequired,
  }),
};

export default FormPaneFooter;
